import React, { useState } from 'react';

function BasicInfoForm() {
  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    dob: '',
    gender: '',
    nationality: '',
    street: '',
    city: '',
    state: '',
    postalCode: '',
    country: '',
    phone: '',
    email: '',
    altPhone: '',
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <form onSubmit={handleSubmit} style={{ maxWidth: 400, margin: '32px auto', padding: 24, background: '#f6f8fa', borderRadius: 8, boxShadow: '0 2px 8px #eee' }}>
      <h2 style={{ marginBottom: 20 }}>Basic Information</h2>
      <div style={{ marginBottom: 16 }}>
        <label htmlFor="firstName" style={{ display: 'block', marginBottom: 6 }}>First Name</label>
        <input
          type="text"
          id="firstName"
          name="firstName"
          value={form.firstName}
          onChange={handleChange}
          required
          style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc' }}
        />
      </div>
      <div style={{ marginBottom: 16 }}>
        <label htmlFor="lastName" style={{ display: 'block', marginBottom: 6 }}>Last Name</label>
        <input
          type="text"
          id="lastName"
          name="lastName"
          value={form.lastName}
          onChange={handleChange}
          required
          style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc' }}
        />
      </div>
      <div style={{ marginBottom: 24 }}>
        <label htmlFor="dob" style={{ display: 'block', marginBottom: 6 }}>Date of Birth</label>
        <input
          type="date"
          id="dob"
          name="dob"
          value={form.dob}
          onChange={handleChange}
          required
          style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc' }}
        />
      </div>
      <div style={{ marginBottom: 24 }}>
        <label style={{ display: 'block', marginBottom: 6 }}>Gender</label>
        <div style={{ display: 'flex', gap: 16 }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <input
              type="radio"
              name="gender"
              value="Male"
              checked={form.gender === 'Male'}
              onChange={handleChange}
              required
            />
            Male
          </label>
          <label style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <input
              type="radio"
              name="gender"
              value="Female"
              checked={form.gender === 'Female'}
              onChange={handleChange}
              required
            />
            Female
          </label>
          <label style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <input
              type="radio"
              name="gender"
              value="Other"
              checked={form.gender === 'Other'}
              onChange={handleChange}
              required
            />
            Other
          </label>
        </div>
      </div>
      <div style={{ marginBottom: 16 }}>
        <label htmlFor="nationality" style={{ display: 'block', marginBottom: 6 }}>Nationality</label>
        <input
          type="text"
          id="nationality"
          name="nationality"
          value={form.nationality}
          onChange={handleChange}
          required
          style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc' }}
        />
      </div>
      <fieldset style={{ marginBottom: 24, border: '1px solid #ccc', borderRadius: 6, padding: 16 }}>
        <legend style={{ fontWeight: 600, color: '#555' }}>Contact Details</legend>
        <div style={{ marginBottom: 12 }}>
          <label htmlFor="phone" style={{ display: 'block', marginBottom: 4 }}>Phone</label>
          <input
            type="tel"
            id="phone"
            name="phone"
            value={form.phone}
            onChange={handleChange}
            required
            style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc' }}
          />
        </div>
        <div style={{ marginBottom: 12 }}>
          <label htmlFor="email" style={{ display: 'block', marginBottom: 4 }}>Email</label>
          <input
            type="email"
            id="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            required
            style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc' }}
          />
        </div>
        <div style={{ marginBottom: 0 }}>
          <label htmlFor="altPhone" style={{ display: 'block', marginBottom: 4 }}>Alternate Phone (optional)</label>
          <input
            type="tel"
            id="altPhone"
            name="altPhone"
            value={form.altPhone}
            onChange={handleChange}
            style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc' }}
          />
        </div>
      </fieldset>
      <fieldset style={{ marginBottom: 24, border: '1px solid #ccc', borderRadius: 6, padding: 16 }}>
        <legend style={{ fontWeight: 600, color: '#555' }}>Address</legend>
        <div style={{ marginBottom: 12 }}>
          <label htmlFor="street" style={{ display: 'block', marginBottom: 4 }}>Street</label>
          <input
            type="text"
            id="street"
            name="street"
            value={form.street}
            onChange={handleChange}
            required
            style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc' }}
          />
        </div>
        <div style={{ marginBottom: 12 }}>
          <label htmlFor="city" style={{ display: 'block', marginBottom: 4 }}>City</label>
          <input
            type="text"
            id="city"
            name="city"
            value={form.city}
            onChange={handleChange}
            required
            style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc' }}
          />
        </div>
        <div style={{ marginBottom: 12 }}>
          <label htmlFor="state" style={{ display: 'block', marginBottom: 4 }}>State</label>
          <input
            type="text"
            id="state"
            name="state"
            value={form.state}
            onChange={handleChange}
            required
            style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc' }}
          />
        </div>
        <div style={{ marginBottom: 12 }}>
          <label htmlFor="postalCode" style={{ display: 'block', marginBottom: 4 }}>Postal Code</label>
          <input
            type="text"
            id="postalCode"
            name="postalCode"
            value={form.postalCode}
            onChange={handleChange}
            required
            style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc' }}
          />
        </div>
        <div style={{ marginBottom: 0 }}>
          <label htmlFor="country" style={{ display: 'block', marginBottom: 4 }}>Country</label>
          <input
            type="text"
            id="country"
            name="country"
            value={form.country}
            onChange={handleChange}
            required
            style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc' }}
          />
        </div>
      </fieldset>
      <button type="submit" style={{ padding: '10px 20px', borderRadius: 4, background: '#1976d2', color: '#fff', border: 'none', fontWeight: 600, cursor: 'pointer' }}>
        Submit
      </button>
      {submitted && (
        <div style={{ marginTop: 20, color: '#388e3c', fontWeight: 500 }}>
          Form submitted! Thank you, {form.firstName} {form.lastName}.
        </div>
      )}
    </form>
  );
}

export default BasicInfoForm;
